import React from 'react'
import WalidacjaSuccessStyle from '../styles/WalidacjaSuccessStyle'
import ButtonSaveFile from '../components/controls/ButtonSaveFile'
import MainStyle from '../styles/MainStyle'
import { krsURL, podatkiGovURL } from '../lib/consts'

const WalidacjaSuccess = ({ licencja }) => (
  <MainStyle>
    <WalidacjaSuccessStyle>
      <h5 className="medium-headline-5">Gratulujemy!</h5>
      <h4 className="medium-headline-4">
        Nie wykryliśmy błędów <br />w Twoim e-Sprawozdaniu!
      </h4>
      <>
        <p className="disabled-headline-5">
          Możesz teraz pobrać e-Sprawozdanie do pliku XML,
          <br />
          a następnie przesłać je drogą elektroniczną do urzędu.
          <br />
          <br />
          Jeśli składasz e-Sprawozdanie do KRS, możesz to zrobić
          <br />
          za pomocą portalu eKRS dostępnego pod adresem:
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={krsURL}
          className="disabled-subtitle-1 link"
        >
          {krsURL}
        </a>
        <p className="disabled-headline-5">
          Jeśli składasz e-Sprawozdanie do Szefa KAS, możesz to zrobić <br />
          za pomocą aplikacji przygotowanej przez Ministerstwo Finansów,
          <br />
          dostępnej pod adresem:
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={podatkiGovURL}
          className="disabled-subtitle-1 link"
        >
          {podatkiGovURL}
        </a>
      </>
      {(licencja.system !== 'ESPR' || licencja.status === '0') && (
        <ButtonSaveFile variant="contained" checkValidity />
      )}
    </WalidacjaSuccessStyle>
  </MainStyle>
)

export default WalidacjaSuccess
